module.exports = __webpack_public_path__ + "img/freespin2.82e75030.png";